import type { DruidInFilter } from '../../../../../../../server/modules/druid';

export type InType = 'in';

export default class InFilter implements DruidInFilter {
  dimension: string;

  field: void;

  fields: void;

  pattern: void;

  type: InType;

  values: Array<string | null>;

  constructor(dimension: string, values: Array<string | null>) {
    this.type = 'in';
    this.dimension = dimension;
    this.values = values;
  }
}
